import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { apiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { hideLoader, showLoader } from '../../../api/loader/loaderSlice';

export const fetchFinancialOverviewData = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await apiClient.get('/dashboard/financial-overview', { params });
  return data;
};

export const useGetFinancialOverviewDataHandler = ({ startDate, endDate, groupedBy, interval, enabled = true }) => {
  const dispatch = useDispatch();

  const params = { startDate, endDate, groupedBy };

  if (interval) {
    params.interval = interval;
  }

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['financial-overview', params],
    queryFn: async (context) => {
      dispatch(showLoader());
      try {
        return await fetchFinancialOverviewData(context);
      } finally {
        dispatch(hideLoader());
      }
    },
    enabled: enabled && Boolean(startDate && endDate && groupedBy),
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || error.message,
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: JSON.stringify(error),
            severity: 'error',
          }),
        );
      }
    }
  }, [dispatch, error, isError]);

  return {
    financialOverview: data,
    isLoading,
  };
};
